import React from 'react';

import { EditableText } from 'components/EditableText';

const EditableTextField = ({
  field,
  helpers,
  haveError,
  ...restProps
}: { field: any; helpers: any; haveError: any } & Record<string, any>) => {
  return <EditableText {...restProps} {...field} />;
};

export default React.memo(EditableTextField) as any;
